import React, { PureComponent } from 'react';

// components
import { YcContactUs } from '../../components';

import './contact.scss';

export class Contact extends PureComponent {
  render() {
    return (
      <div className="p-contact">
        <section className="s-history">
          <YcContactUs />
        </section>
      </div>
    );
  }
}
